<template>
  <div :id="'vehicle-info-container-wrapper-' + vehicle.id"
       class="vehicle-info-container-wrapper d-flex flex-column position-relative">
    <div
        class="vehicle-info-container-wrapper__info-intro d-flex flex-column-reverse flex-sm-column-reverse flex-lg-row flex-grow-1">

      <div class="vehicle-info-container-wrapper__info-intro__h2 flex-grow-1">
        <h2>
          {{ vehicle.make }} {{ vehicle.model }}
        </h2>

        <template v-if="!isDriver">

          <ButtonComponent type="button" data-bs-target="#selectVehicleModal" data-bs-dismiss="modal" aria-label="Close"
                           class="modal-order-button d-flex align-items-center justify-content-center"
                           @click="onSubmit(routesConst.ORDER)">
            <template #btnContent>
              <div>
                {{ $t('order.order') }}
              </div>
            </template>
          </ButtonComponent>

        </template>

        <template v-else>

            <ButtonComponent type="button" data-bs-target="#selectVehicleModal" data-bs-dismiss="modal" aria-label="Close"
                             class="modal-order-button d-flex align-items-center justify-content-center"
                             @click="onSubmit(routesConst.CHOOSE_CUSTOM_ROUTE)">
              <template #btnContent>
                <div>
                  {{ $t('order.order') }}
                </div>
              </template>
            </ButtonComponent>

        </template>

      </div>

      <div class="vehicle-info-container-wrapper__info-intro__img position-relative">
        <img class="w-100" :src="vehicle.vehicle_main_image === null ? '' : vehicle.vehicle_main_image.path"
             alt="vehicle-image">
        <div class="font-medium vehicle-card__header__data font-medium position-absolute top-0 end-0">
          {{ vehicle.seats }} {{ $t($helpers.wordEnding(vehicle.seats)) }}
        </div>
      </div>
    </div>

    <div class="hr-h-margin-top"></div>

    <div class="vehicle-info-container-wrapper__content d-flex">
      <div class="vehicle-info-container-wrapper__content__info-details d-flex flex-column flex-sm-column flex-lg-row">

        <div class="vehicle-info-container-wrapper__content__info-details__container-1">

          <div
              class="vehicle-info-container-wrapper__content__info-details__container-1__item d-flex justify-content-between">
            <div class="font-weight-400 font-big-400">{{ $t('maker') }}</div>
            <div class="font-big">{{ vehicle.make }}</div>
          </div>

          <div
              class="vehicle-info-container-wrapper__content__info-details__container-1__item d-flex justify-content-between">
            <div class="font-weight-400 font-big-400">{{ $t('model') }}</div>
            <div class="font-big">{{ vehicle.model }}</div>
          </div>

          <div
              class="vehicle-info-container-wrapper__content__info-details__container-1__item d-flex justify-content-between">
            <div class="font-weight-400 font-big-400">{{ $t('price') }}</div>
            <div class="font-big">{{ vehicle.price }}</div>
          </div>

          <div
              class="vehicle-info-container-wrapper__content__info-details__container-1__item d-flex justify-content-between">
            <div class="font-weight-400 font-big-400">{{ $t('seating_seats') }}</div>
            <div class="font-big">{{ vehicle.seats }}</div>
          </div>
        </div>

        <div class="hr-v"></div>

        <div class="vehicle-info-container-wrapper__content__info-details__container-2">
          <VehicleCardFreeItemWrapperComponent :show-item-text="true"></VehicleCardFreeItemWrapperComponent>
        </div>

      </div>
    </div>

    <div class="hr-h"></div>

    <div class="vehicle-info-container-wrapper__info-photo parent-photo-container">

      <template v-for="image in vehicle.vehicle_additional_images" :key="image.id">
        <div
            class="car-image-container"
            @click="$helpers.openModal($event, {id: 'image-vehicle-' + image.id}, 'custom-modal-backdrop-1')">
          <img :id="'image-'+image.id.toString()" :src="image.path" alt="car-1">
          <div class="middle"></div>
        </div>

        <Teleport to="body">
          <ModalComponent
              :is-main-modal="false"
              :z-index-custom="'z-index-custom-1'"
              :id="'image-vehicle-'+image.id.toString()"
              :backdrop="'custom-modal-backdrop-1'"
              :body-overflow="'body-overflow-1'">
            <template #body-content>
              <div class="modal-body image-modal-body">
                <h1>
                  <img :id="'image-'+image.id.toString()" :src="image.path" alt="car">
                </h1>
              </div>
            </template>
          </ModalComponent>
        </Teleport>

      </template>
    </div>
  </div>
</template>

<script lang="ts">
import './vehicleInfoWrapper.scss';

import {defineComponent, type PropType} from "vue";
import {useStore} from "vuex";

// @ts-ignore
import VehicleCardFreeItemWrapperComponent from "../vehicleCardFreeItemWrapper/VehicleCardFreeItemWrapperComponent.vue";
// @ts-ignore
import ButtonComponent from "../Button/ButtonComponent.vue";
// @ts-ignore
import ModalComponent from "../modal/ModalComponent.vue";

import {routesConst} from "../../routes";
import {modalEvents} from "../../helpers/modalEvents";
import formValidationService from "../../services/formValidationService";
import type {IApiResponseVehicle} from "@/interfaces/apiResponseInterfaces/IApiResponseVehicle.interface";

export default defineComponent({
  name: 'VehicleInfoWrapperComponent',
  emits: ['selected'],
  components: {
    ButtonComponent,
    VehicleCardFreeItemWrapperComponent,
    ModalComponent
  },
  props: {
    vehicle: {
      type: Object as PropType<IApiResponseVehicle>,
      required: true
    },
    isDriver: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      routesConst: routesConst,
      isValidForm: true,
    }

  },
  setup() {
    const store = useStore();

    return {
      store
    }
  },

  methods: {
    onSubmit(route: routesConst): void {
      let isValid = true;

      switch (this.$route.name) {
        case routesConst.CHOOSE_VEHICLE:
        case routesConst.CHOOSE_CUSTOM_ROUTE:
          let withDriver = this.store.state.order.withDriver;
          const state = ! withDriver ? this.store.state.orderFalseDriver : this.store.state.orderTrueDriver;

          isValid = formValidationService.validateRentLocation(withDriver, this.store);

          if (! withDriver) {
            const isValidDateTime = formValidationService.validateRentDateTime(state);

            isValid = isValid && isValidDateTime;
          }

          break;
      }

      if (isValid) {
        this.store.commit('vehicle/SET_STATE_PROP_VALUE', [{
          prop: 'selectedVehicle',
          value: this.vehicle
        }, {prop: 'selectedId', value: this.vehicle.id}]);
        // this.store.commit('vehicle/SET_STATE_PROP_VALUE', [{prop: 'selectedId', value: this.vehicle.id}]);

        this.$router.push(route);
      }

      modalEvents.closeModal({
        id: 'selected-vehicle-' + this.vehicle.id,
        backdrop: 'custom-modal-backdrop-0',
        bodyOverflow: 'body-overflow'
      });
    },
  },
})
</script>

